export default __webpack_public_path__ + "static/media/H1015.4.8b7ca0b1.mp3";